import routerOptions0 from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/opt/atlassian/pipelines/agent/build/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}